export function getKeyPressCharacter(e) {
  if (!e) {
    return "";
  }
  // Space
  if (e.keyCode === 32) {
    return " ";
  }
  if (e.keyCode < 0x30) {
    return "";
  }

  let ascii,
    key = e.key;
  if (key.length == 1) {
    ascii = key.charCodeAt(0);
    if (ascii < 128 && e.ctrlKey) {
      ascii = ascii & 0x1f;
    }
  }
  if (typeof ascii == "number" && ascii < 128) {
    return String.fromCharCode(ascii);
  } else {
    return "";
  }
}
